import React from "react"
import { Tooltip } from "antd"
import PropTypes from "prop-types"
import "./UserBadge.scss"

// utils
import { getUserInitials } from "./userBadgeUtils"

const UserBadge = ({ user, size = "sm", className, type }) => {
  const initials = getUserInitials(user)

  if (!initials) return null

  const classNames = [`user-badge-container no-text-highlight ${size}-size${className ? ` ${className}` : ""}`]
  if (type) {
    classNames.push(`${type}--user-badge`)
  }

  return (
    <Tooltip
      title={user}
      placement="bottom"
    >
      <div className={classNames.join(" ")}>{initials}</div>
    </Tooltip>
  )
}

UserBadge.propTypes = {
  user: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md"]),
  type: PropTypes.string,
  className: PropTypes.string,
}

export default UserBadge
